import { render, staticRenderFns } from "./primary-kpi-table.vue?vue&type=template&id=3186c54a&scoped=true"
import script from "./primary-kpi-table.vue?vue&type=script&lang=ts"
export * from "./primary-kpi-table.vue?vue&type=script&lang=ts"
import style0 from "./primary-kpi-table.vue?vue&type=style&index=0&id=3186c54a&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3186c54a",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/src/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3186c54a')) {
      api.createRecord('3186c54a', component.options)
    } else {
      api.reload('3186c54a', component.options)
    }
    module.hot.accept("./primary-kpi-table.vue?vue&type=template&id=3186c54a&scoped=true", function () {
      api.rerender('3186c54a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/primary-kpi-step/primary-kpi-table.vue"
export default component.exports